

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';

type CaseId = "animals" | "election" | "covid" | "defect_prevention";
type PurposeId = "train" | "predict";
type FileId = "animals" | "election" | "covid" | "covid_a" | "covid_b" | "defect_prevention";

interface CaseStudyCSV {
    caseId: CaseId,
    purposeId: PurposeId,
    fileId: FileId,
    text: string,
}

@Component
export default class CsvSelector extends Vue {
    caseStudyCSVs: CaseStudyCSV[] = [];
    caseStudyHeaders: {[key in CaseId]: string[]} = {animals: [], election: [], covid: [], defect_prevention: []};
    selectionItems: CaseStudyCSV[] = [];

    @Prop({ default: 'train' })
    purpose?: PurposeId;

    created() {
        this.initialize();
    }

    /**
     * 現在の言語に合わせてメンバーを初期化します。
     */
    private initialize() {
        // 
        this.caseStudyCSVs = [
            {caseId: "animals", purposeId: "train", fileId: "animals", text: this.$t("caseStudyCSV.animals.trainingText")},
            {caseId: "animals", purposeId: "predict", fileId: "animals", text: this.$t("caseStudyCSV.animals.predictionText")},
            {caseId: "election", purposeId: "train", fileId: "election", text: this.$t("caseStudyCSV.election.trainingText")},
            {caseId: "election", purposeId: "predict", fileId: "election", text: this.$t("caseStudyCSV.election.predictionText")},
            {caseId: "covid", purposeId: "train", fileId: "covid", text: this.$t("caseStudyCSV.covid.trainingText")},
            {caseId: "covid", purposeId: "predict", fileId: "covid_a", text: this.$t("caseStudyCSV.covid.predictionTextA")},
            {caseId: "covid", purposeId: "predict", fileId: "covid_b", text: this.$t("caseStudyCSV.covid.predictionTextB")},
            {caseId: "defect_prevention", purposeId: "train", fileId: "defect_prevention", text: this.$t("caseStudyCSV.defect_prevention.trainingText")},
            {caseId: "defect_prevention", purposeId: "predict", fileId: "defect_prevention", text: this.$t("caseStudyCSV.defect_prevention.predictionText")},
        ];
        // CSVヘッダー文字列
        this.caseStudyHeaders = {
            animals: this.$t('caseStudyCSV.animals.headerText').split(','),
            election: this.$t('caseStudyCSV.election.headerText').split(','),
            covid: this.$t('caseStudyCSV.covid.headerText').split(','),
            defect_prevention: this.$t('caseStudyCSV.defect_prevention.headerText').split(',')
        };

        const selectionItems = this.caseStudyCSVs.filter(item => item.purposeId === this.purpose);
        if (sessionModule.getTrainingData) {
            this.selectionItems = selectionItems.filter(item => item.caseId === sessionModule.getTrainingData.selectedCase);
        } else {
            this.selectionItems = selectionItems;
        }
    }

    @Watch('$i18n.locale')
    private changeLocale(newVal: string) {
        this.initialize();
    }

    private async onChange({caseId, fileId}: CaseStudyCSV) {
        let language: string;

        switch (this.purpose) {
            case "train":
                language = this.$i18n.locale;
                sessionModule.SET_INPUT_TRAINING_DATA_HEADERS(this.caseStudyHeaders[caseId]);
                await sessionModule.selectTrainingSet({caseId, fileId, language});
                break;
            case "predict":
                let trainingData = sessionModule.getTrainingData;
                language = trainingData.selectedLanguage;
                sessionModule.SET_INPUT_PREDICT_DATA_HEADERS(trainingData.data[0].slice(0, -1));
                await sessionModule.selectPredictSet({caseId, fileId, language});
                break;
        }
    }
}
